<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear @press-enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.status" placeholder="请选择使用状态" allow-clear>
                  <a-select-option :value="0">未使用</a-select-option>
                  <a-select-option :value="1">已使用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否过期">
                <a-select v-model="queryParam.expire" placeholder="请选择是否过期" allow-clear>
                  <a-select-option :value="0">未过期</a-select-option>
                  <a-select-option :value="1">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 0" color="green">未使用</a-tag>
          <a-tag v-else-if="text === 1" color="blue">已使用</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="expire" slot-scope="text">
          <a-tag v-if="text === 0" color="blue">未过期</a-tag>
          <a-tag v-else-if="text === 1" color="red">已过期</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="validityStart" slot-scope="text">
          {{ formatDateTime(text) }}
        </span>
        <span slot="validity" slot-scope="text">
          {{ formatDateTime(text) }}
        </span>
        <span slot="createTime" slot-scope="text">
          {{ formatDateTime(text) }}
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="value => `共 ${value} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserCoupon } from '@/api/userCoupon/userCoupon'
import { parseTime } from '@/utils/ruoyi'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserCoupon',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      loading: false,
      total: 0,
      queryParam: {
        mobile: undefined,
        status: undefined,
        expire: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券金额',
          dataIndex: 'couponPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '满额条件',
          dataIndex: 'couponRequire',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '使用状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '有效期开始',
          dataIndex: 'validityStart',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'validityStart' }
        },
        {
          title: '是否过期',
          dataIndex: 'expire',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'expire' }
        },
        {
          title: '有效期',
          dataIndex: 'validity',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'validity' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      pageUserCoupon(this.queryParam).then(response => {
        const data = (response && response.data) || {}
        this.list = data.records || []
        this.total = data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        status: undefined,
        expire: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    formatDateTime (value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const formatted = parseTime(value)
      return formatted || value
    }
  }
}
</script>
